/*import "@babel/polyfill";*/
import React, { Component } from 'react';
import './App.scss';
import 'bootstrap/dist/css/bootstrap.css';
import Test from "./components/quiz/Test";
import TestStartPage from "./components/quiz/TestStartPage";
import TestStartPageHeader from "./components/quiz/TestStartPageHeader";
import DevMenu from "./components/quiz/DevMenu";
import $ from "jquery";
import TestStartInfoPage from "./components/quiz/TestStartInfoPage";
import DetectBrowser from "./components/quiz/DetectBrowser";
import SprachtestPostMsg from "./components/quiz/SprachtestPostMsg";
import SprachtestPostMsgTestPage from "./components/quiz/SprachtestPostMsgTestPage";

/*import zeitJs from 'https://sprachtest.local.de/themes/custom/sprachtest_frontend/js/sprachtest_zeit.js';*/
/*require('https://sprachtest.local.de/themes/custom/sprachtest_frontend/js/sprachtest_zeit.js');*/
class App extends Component {

  constructor(){
      super();
      this.state = {
        TestStartState: false,
          zeitclass: '',
      }
  }
    iframeInfo(evt) {
       /* console.log('in iframe info')*/
        let message;
        message = "LISTNER from react-app: Document Height - " + evt.data.height + " LISTNER: Document Width - " + evt.data.width;
        console.log(message);
    }
    componentDidMount() {
        window.parent.postMessage({width:document.body.scrollWidth,height:document.body.scrollHeight}, '*');
       /* window.parent.postMessage({'width': document.body.scrollWidth, 'height': document.body.scrollHeight}, '*');*/
        /*const script = document.createElement("script");
        script.async = true;
        script.src = "https://sprachtest.local.de/themes/custom/sprachtest_frontend/js/sprachtest_zeit.js";
        document.body.appendChild(script);*/


      /*zeitJs()*/
        let urlpath;
        if(process.env.NODE_ENV === "development"){
            //urlpath = "https://sprachtest.local.de/einstufungstest-englisch?pid=57&gid=79&auth_id=1";
            urlpath = "https://sprachtest.local.de/einstufungstest-englisch?version=spiframe&footer=no&brand=zeit";
            //urlpath = "https://sprachtest.local.de/einstufungstest-deutsch";
        }else{
            urlpath = window.location.href;
        }
       /* console.log(urlpath)*/
        let location = new URL(urlpath);
        if(location.searchParams.get("brand") && (location.searchParams.get("brand") == 'zeit')) {
            /*zeitclass = 'zeit';*/
            this.setState({zeitclass:'zeit'});
        }
     /*   console.log(this.state.zeitclass)*/


        if (window.addEventListener) {
            window.addEventListener("message", this.iframeInfo, false);
        } else {
            window.attachEvent("onmessage", this.iframeInfo);
        }

    }
  startTest(){
    this.setState({TestStartState:true})
      $('html,body').animate({
              scrollTop: $("html").offset().top},
          'slow');
    /*console.log(document.body.scrollHeight)*/
     /* window.parent.postMessage({'width': window.innerWidth, 'height': window.innerHeight}, '*');*/

  }
  render() {
      if (process.env.NODE_ENV === "development") {
          return (
              this.state.TestStartState?
                  <div className={this.state.zeitclass}>
                      <div className="Sprachtest-App">
                         <DevMenu/>
                          <div className="main">
                              <Test/>
                            {/*  <SprachtestPostMsg/>*/}
                          </div>
                      </div>
                  </div>
             :
                  <div className={this.state.zeitclass}>
                      <div className="Sprachtest-App">
                          <DevMenu/>
                          <div className="main startPage">
                              <TestStartPageHeader/>
                              <div className="StartButton">
                                 {/* <SprachtestPostMsgTestPage/>*/}
                                    <TestStartPage/>
                                    <button type="button"
                                          className="btn btn-primary yes"
                                          onClick={this.startTest.bind(this)}>
                                      Test starten
                                    </button>
                                    <TestStartInfoPage/>
                                    <button type="button"
                                        className="btn btn-primary yes"
                                        onClick={this.startTest.bind(this)}>
                                      Test starten
                                    </button>
                              </div>
                          </div>
                      </div>
                  </div>
          );
      } else {
          return (
              this.state.TestStartState?
                  <div className={this.state.zeitclass}>
                      <div className="Sprachtest-App">
                          <DetectBrowser/>
                          <div className="main">
                              <Test/>
                          </div>
                      </div>
                  </div> :
                  <div className={this.state.zeitclass}>
                      <div className="Sprachtest-App">
                          <div className="main startPage">
                              <TestStartPageHeader/>
                              <div className="StartButton">
                                <TestStartPage/>
                                 <button type="button"
                                       className="btn btn-primary yes"
                                       onClick={this.startTest.bind(this)}>
                                  Test starten
                                 </button>
                                 <TestStartInfoPage/>
                                  <button type="button"
                                          className="btn btn-primary yes"
                                          onClick={this.startTest.bind(this)}>
                                      Test starten
                                  </button>
                              </div>
                          </div>
                      </div>
                  </div>
          );
      }
  }
}

export default App;
